import fieldOptions from '../config/fieldOptions';

export const getAllFieldOptions = (manualFieldOptions = []) => {
  // FieldNames that need full technology objects preserved for domain filtering
  const technologyFieldNames = ['staffingTechFocSpecOptions', 'implementationTechFocSpecOptions'];

  // Group manual options by fieldName
  const groupedManual = manualFieldOptions.reduce((acc, option) => {
    const { fieldName, key, label } = option;
    if (!acc[fieldName]) acc[fieldName] = [];

    // For technology fieldNames, preserve the full object (needed for domain filtering)
    if (technologyFieldNames.includes(fieldName)) {
      acc[fieldName].push(option);
    } else {
      // For other fieldNames, keep only key + label
      acc[fieldName].push({ key, label });
    }
    return acc;
  }, {});

  // Merge with defaults
  const merged = {};
  Object.keys(fieldOptions).forEach(fieldName => {
    // Skip function properties and specific object mappings - we only want array options
    if (typeof fieldOptions[fieldName] === 'function' ||
        fieldName === 'serviceDomainTechnologyMapping') {
      return;
    }

    let combined = [
      ...(fieldOptions[fieldName] || []),
      ...(groupedManual[fieldName] || []),
    ];

    // Pull out add_new_option if it exists
    const withoutAddNew = combined.filter(opt => opt.key !== 'add_new_option');
    const addNew = combined.find(opt => opt.key === 'add_new_option');

    // Sort alphabetically by label (case-insensitive)
    withoutAddNew.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
    );

    // Append add_new_option at the end if it exists
    combined = addNew ? [...withoutAddNew, addNew] : withoutAddNew;

    merged[fieldName] = combined;
  });

  // Include any technology fieldNames from groupedManual that don't exist in fieldOptions
  Object.keys(groupedManual).forEach(fieldName => {
    if (!merged[fieldName]) {
      merged[fieldName] = groupedManual[fieldName];
    }
  });

  return merged;
};